import Request from './request'

const Servers  = {
  getServers (params, callback) {
    Request.get('servers/index', params).then(callback).catch(this.bad_answer)
  },
  getServerList(callback){
    Request.get('servers/list').then(callback).catch(this.bad_answer)
  },
  getServerInfo (id, callback) {
    Request.get('servers/view/' + id).then(callback).catch(this.bad_answer)
  },
  updateServer (id, params, callback) {
    Request.post('servers/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateServerInstance (id, params, callback) {
    Request.post('servers/update-instance/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Servers
